<template>
  <div class="remark-card">
    <slot></slot>
  </div>
</template>

<script>
export default {
  data() {
    return {

    }
  }
}
</script>

<style lang="scss" scoped>
.remark-card {
  background: #fff8ea;
  border-radius: 2px;
  border: 1px solid #ffc68b;
  padding: 4px 8px;
  color: #f3a000;
}
</style>